export default {
  INSTALL_VOUCHER_TOKEN_UPDATE: 'INSTALL_VOUCHER_TOKEN_UPDATE',
  INSTALL_VOUCHER_RESET: 'INSTALL_VOUCHER_RESET',
  INSTALL_VOUCHER_SET: 'INSTALL_VOUCHER_SET',
  INSTALL_VOUCHER_VALIDATE_DONE: 'INSTALL_VOUCHER_VALIDATE_DONE',
  INSTALL_VOUCHER_VALIDATE_REQUEST: 'INSTALL_VOUCHER_VALIDATE_REQUEST',
  INSTALL_VOUCHER_VALIDATE_SUCCESS: 'INSTALL_VOUCHER_VALIDATE_SUCCESS',
  INSTALL_VOUCHER_VALIDATE_USED: 'INSTALL_VOUCHER_VALIDATE_USED',
  INSTALL_VOUCHER_VALIDATE_USED_VALIDATE_SUCCESS: 'INSTALL_VOUCHER_VALIDATE_USED_VALIDATE_SUCCESS',
  INSTALL_VOUCHER_VALIDATE_INVALID: 'INSTALL_VOUCHER_VALIDATE_INVALID',
  FEEDBACK_REQUEST: 'FEEDBACK_REQUEST',
  FEEDBACK_SUCCESS: 'FEEDBACK_SUCCESS',
  FEEDBACK_ERROR: 'FEEDBACK_ERROR',
  FETCH_QUESTIONS_REQUEST: 'FETCH_QUESTIONS_REQUEST',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
  FETCH_QUESTIONS_ERROR: 'FETCH_QUESTIONS_ERROR',
  FETCH_SITE_REQUEST: 'FETCH_SITE_REQUEST',
  FETCH_SITE_SUCCESS: 'FETCH_SITE_SUCCESS',
  FETCH_SITE_ERROR: 'FETCH_SITE_ERROR',
  FETCH_SITE_NOT_FOUND: 'FETCH_SITE_NOT_FOUND',
  POST_JOB_SUCCESS: 'POST_JOB_SUCCESS',
  JOB_CONNECT_MORE_REQUEST: 'JOB_CONNECT_MORE_REQUEST',
  JOB_CONNECT_MORE_SUCCESS: 'JOB_CONNECT_MORE_SUCCESS',
  JOB_CONNECT_MORE_ERROR: 'JOB_CONNECT_MORE_ERROR',
  USER_LOGIN_CHECK_SUCCESS: 'USER_LOGIN_CHECK_SUCCESS',
  FETCH_JOB_REQUEST: 'FETCH_JOB_REQUEST',
  FETCH_JOB_ERROR: 'FETCH_JOB_ERROR',
  FETCH_JOB_SUCCESS: 'FETCH_JOB_SUCCESS',
  FETCH_JOB_NOT_FOUND: 'FETCH_JOB_NOT_FOUND',
  FETCH_CATEGORY_SUCCESS: 'FETCH_CATEGORY_SUCCESS',
  FETCH_CATEGORY_ERROR: 'FETCH_CATEGORY_ERROR',
  FETCH_LOCATION_SUCCESS: 'FETCH_LOCATION_SUCCESS',
  FETCH_LOCATION_ERROR: 'FETCH_LOCATION_ERROR',
  MODAL_HIPROJECTS_STATUS: 'MODAL_HIPROJECTS_STATUS',
  MODAL_CLOSEJOB_STATUS: 'MODAL_CLOSEJOB_STATUS',
  HARD_REDIRECT_TO: 'HARD_REDIRECT_TO',
  CLOSE_JOB_SUCCESS: 'CLOSE_JOB_SUCCESS',
  FETCH_JOB_INVITATIONS_REQUEST: 'FETCH_JOB_INVITATIONS_REQUEST',
  FETCH_JOB_INVITATIONS_SUCCESS: 'FETCH_JOB_INVITATIONS_SUCCESS',
  FETCH_JOB_INVITATIONS_ERROR: 'FETCH_JOB_INVITATIONS_ERROR',
  FETCH_JOB_STATUS_SUCCESS: 'FETCH_JOB_STATUS_SUCCESS',
  FETCH_JOB_STATUS_ERROR: 'FETCH_JOB_STATUS_ERROR',
  MARK_CHECKPOINT: 'MARK_CHECKPOINT',
  UNMARK_CHECKPOINT: 'UNMARK_CHECKPOINT',
  SET_IS_FIRST_VIEW: 'SET_IS_FIRST_VIEW',
  FETCH_RECOMMENDATIONS_SUCCESS: 'FETCH_RECOMMENDATIONS_SUCCESS',
  FETCH_RECOMMENDATIONS_ERROR: 'FETCH_RECOMMENDATIONS_ERROR',
  FETCH_JOB_CONNECTIONS_REQUEST: 'FETCH_JOB_CONNECTIONS_REQUEST',
  FETCH_JOB_CONNECTIONS_SUCCESS: 'FETCH_JOB_CONNECTIONS_SUCCESS',
  FETCH_JOB_CONNECTIONS_ERROR: 'FETCH_JOB_CONNECTIONS_ERROR',
  EXTRA_INSTALL_VOUCHER_VALIDATE_INIT: 'EXTRA_INSTALL_VOUCHER_VALIDATE_INIT',
  EXTRA_INSTALL_VOUCHER_VALIDATE_REQUEST: 'EXTRA_INSTALL_VOUCHER_VALIDATE_REQUEST',
  EXTRA_INSTALL_VOUCHER_VALIDATE_SUCCESS: 'EXTRA_INSTALL_VOUCHER_VALIDATE_SUCCESS',
  EXTRA_INSTALL_VOUCHER_VALIDATE_DONE: 'EXTRA_INSTALL_VOUCHER_VALIDATE_DONE',
  EXTRA_INSTALL_VOUCHER_REMOVE_SUCCESS: 'EXTRA_INSTALL_VOUCHER_REMOVE_SUCCESS'
};
